/* eslint-disable react/prop-types */

import React, { useEffect, useState } from "react";
import { getRandomIntByRange } from "~utils/helpers";
import { useTimeout } from "~utils/hooks";

const Flipbook = ({ actionFrameLength = 12, image, initialDelay = 0 }) => {
  const [actionFrame, setActionFrame] = useState(null);
  const [idleFrame, setIdleFrame] = useState(0);
  const [idleLoopCount, setIdleLoopCount] = useState(0);
  const [idleLoopThreshold, setIdleLoopThreshold] = useState(
    getRandomIntByRange(5, 12)
  );
  const [rendered, setRendered] = useState(false);
  const [withAction, setWithAction] = useState(false);

  const [actionLoaded, setActionLoaded] = useState(false);
  const [idleLoaded, setIdleLoaded] = useState(0);
  const [loadedIdleFrames, setLoadedIdleFrames] = useState([]);
  const [loadedActionFrames, setLoadedActionFrames] = useState([]);

  //

  const fps = 12;

  const idleFrames = [
    `/images/animation-${image}/${image}-1.svg`,
    `/images/animation-${image}/${image}-1b.svg`,
    `/images/animation-${image}/${image}-1c.svg`
  ];

  const action = [];

  Array(actionFrameLength)
    .fill(null)
    .forEach((_, frameIndex) => {
      action.push(`/images/animation-${image}/${image}-${frameIndex + 1}.svg`);
    });

  //

  const addLoadedIdleFrame = frameIndex => {
    if (!loadedIdleFrames.includes(frameIndex)) {
      const loadedFrames = JSON.parse(JSON.stringify(loadedIdleFrames));

      loadedFrames.push(frameIndex);

      setLoadedIdleFrames(loadedFrames);
      setIdleLoaded(loadedFrames.length === idleFrames.length);
    }
  };

  const addLoadedActionFrame = frameIndex => {
    if (!loadedActionFrames.includes(frameIndex)) {
      const loadedFrames = JSON.parse(JSON.stringify(loadedActionFrames));

      loadedFrames.push(frameIndex);

      setLoadedActionFrames(loadedFrames);
      setActionLoaded(loadedFrames.length === action.length);
    }
  };

  // useEffect(() => {
  //   if (idleLoaded) {
  //     console.log(`idleLoaded: `, idleLoaded);
  //   }
  // }, [idleLoaded]);

  // useEffect(() => {
  //   if (actionLoaded) {
  //     console.log(`actionLoaded: `, actionLoaded);
  //   }
  // }, [actionLoaded]);

  //

  const animateIdle = () => {
    if (idleFrame + 1 < 3) {
      setTimeout(() => {
        setIdleFrame(idleFrame + 1);
      }, 1000 / fps);
    } else {
      const newIdleLoopCount = idleLoopCount + 1;

      if (newIdleLoopCount > idleLoopThreshold) {
        if (!actionLoaded || !withAction) {
          setTimeout(() => {
            setIdleFrame(0);
            setIdleLoopCount(newIdleLoopCount);
          }, 1000 / fps);
        } else {
          setTimeout(() => {
            setIdleFrame(null);
            setIdleLoopCount(0);
            setIdleLoopThreshold(getRandomIntByRange(5, 12));
            setActionFrame(0);
          }, 1000 / fps);
        }
      } else {
        setTimeout(() => {
          setIdleFrame(0);
          setIdleLoopCount(newIdleLoopCount);
        }, 1000 / fps);
      }
    }
  };

  const animateAction = () => {
    if (actionFrame + 1 < actionFrameLength) {
      setTimeout(() => {
        setActionFrame(actionFrame + 1);
      }, 1000 / fps);
    } else {
      setTimeout(() => {
        setActionFrame(null);
        setIdleFrame(0);
      }, 1000 / fps);
    }
  };

  //

  useEffect(() => {
    if (idleFrame !== null) {
      animateIdle();
    }
  }, [idleFrame]);

  useEffect(() => {
    if (actionFrame !== null) {
      animateAction();
    }
  }, [actionFrame]);

  useTimeout(() => {
    setRendered(true);
  }, 1000 + initialDelay);

  useTimeout(() => {
    setWithAction(true);
  }, 3000 + initialDelay);

  //

  return (
    <div className={`square transition-opacity ${rendered ? `` : `opacity-0`}`}>
      {idleFrames?.[0] &&
        idleFrames.map((frame, frameIndex) => {
          const key = `${image}-idle-${frameIndex}`;

          return (
            <figure
              key={key}
              className={`${
                idleFrame === frameIndex ? `` : `opacity-0`
              } w-full h-full absolute top-0 right-0 bottom-0 left-0`}
            >
              <img
                className={`${
                  idleLoaded ? `` : `opacity-0`
                } w-full h-full relative block object-cover`}
                src={frame}
                onLoad={() => addLoadedIdleFrame(frameIndex)}
                alt={`${image} animation`}
              />
            </figure>
          );
        })}

      {idleLoaded &&
        withAction &&
        action.map((frame, frameIndex) => {
          const key = `${image}-action-${frameIndex}`;

          return (
            <figure
              key={key}
              className={`${
                actionFrame === frameIndex ? `` : `opacity-0`
              } w-full h-full absolute top-0 right-0 bottom-0 left-0`}
            >
              <img
                className={`${
                  actionLoaded ? `` : `opacity-0`
                } w-full h-full relative block object-cover`}
                src={frame}
                onLoad={() => addLoadedActionFrame(frameIndex)}
                alt={`${image} animation`}
              />
            </figure>
          );
        })}
    </div>
  );
};

export default Flipbook;
